import server from "./server";

export const getClientsApi = async () => {
  const response = await server().get("/clients");
  return response.data;
};

export const getSingleClientApi = async ({ slug }) => {
  const response = await server().get(`/clients/slug/${slug}`);
  return response.data;
};

export const getSingleClientByIdApi = async ({ id }) => {
  const response = await server().get(`/clients/${id}`);
  return response.data;
};

export const createClientApi = async ({ data }) => {
  const response = await server().post("/clients", data);
  return response.data;
};

export const updateClientApi = async ({ id, data }) => {
  const response = await server().put(`/clients/${id}`, data);
  return response.data;
};

export const deleteClientApi = async ({ id }) => {
  const response = await server().delete(`/clients/${id}`);
  return response.data;
};
